/** @jsx jsx */

import { ReactNode } from 'react';

import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    padding: 15px 0px;
  `,
  title: css`
    margin-top: 0;
    padding: 10px 15px;
  `,
  list: css`
    padding: 0;
    list-style: none;
    margin: 0;
    line-height: 1.75em;
  `,
};

export interface Props {
  /** The child nodes. */
  children: ReactNode;
  /** The title. */
  title?: string;
}

/**
 * Renders a Section to be used with Sidebar.
 *
 * @param props
 */
function Section(props: Props) {
  const { children, title } = props;
  return (
    <section css={Styles.root}>
      {title && <h2 css={Styles.title}>{title}</h2>}
      <ul css={Styles.list}>{children}</ul>
    </section>
  );
}

export default Section;
